import { render } from "./DemosTable.vue?vue&type=template&id=7ef4c015"
import script from "./DemosTable.vue?vue&type=script&lang=js"
export * from "./DemosTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__